import { render, staticRenderFns } from "./EditorBottomInnerSections.vue?vue&type=template&id=50044644&"
import script from "./EditorBottomInnerSections.vue?vue&type=script&lang=js&"
export * from "./EditorBottomInnerSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports